/*
  © 2025 TeamDrop
  https://www.teamdrop.com.br
*/


class ProductForm extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector('form')

    // Proteção: se não houver form, não executa nada
    if (!this.form) return

    this.productOptions = this.form.querySelectorAll('.product-options [name*="option"]')
    this.atcBtn = this.form.querySelector('.btn-atc')
    this.buyBtn = this.form.querySelector('.btn-buy')

    this.form.addEventListener('submit', event => this.onSubmit(event))

    this.productOptions.forEach(elem =>
      elem.addEventListener('change', event => this.onChangeProductOption(event)))

    this.buyBtn?.addEventListener('click', event => this.onClickBuyBtn(event))

    this.querySelectorAll('select[name="id"').forEach(select => {
      select.addEventListener('change', () => this.onChangeVariant(select))
    })

    this.handleOutOfStockOptions()
  }

  async onChangeProductOption(event) {
    event.preventDefault()

    const selectedOptions = []

    this.productOptions.forEach(elem => {
      if (elem.type === 'radio' && elem.checked) {
        selectedOptions.push(elem.value)
      } else if (elem.type === 'select-one') {
        selectedOptions.push(elem.value)
      }
    })

    // console.log(selectedOptions)

    const selectedVariant = JSON.parse(this.form.dataset.variants).find(variant =>
      JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    )

    console.log(selectedVariant)

    this.adjustPricing(selectedVariant)
    this.adjustButtons(selectedVariant)
    this.handleOutOfStockOptions()

    if (selectedVariant) {
      this.querySelector('[name="id"]').value = selectedVariant.id

      if (this.closest('.product-main')) {
        const url = new URL(window.location)
        url.searchParams.set('variant', selectedVariant.id)
        window.history.replaceState({}, '', url)
      }

      window.dispatchEvent(new CustomEvent('td.product.variant.change', {
        detail: selectedVariant
      }))

      this.fetchNewDocument(selectedVariant)
    }
  }

  adjustPricing(selectedVariant) {
    if (!selectedVariant) return

    const comparePrice = this.form.querySelector('.product-price-compare')
    const finalPrice = this.form.querySelector('.product-price-final')
    const compareBadge = this.form.querySelector('.product-sale-badge')
    const soldOutBadge = this.form.querySelector('.product-sold-out-badge')

    if (selectedVariant.compare_at_price > selectedVariant.price) {
      comparePrice.textContent = window.Shopify.formatMoney(selectedVariant.compare_at_price)
      comparePrice.removeAttribute('hidden')
      finalPrice.innerHTML = `<span class="visually-hidden">${window.theme.locales.product.sale_price}}</span>${window.Shopify.formatMoney(selectedVariant.price)}`
      finalPrice.classList.add('product-price-final-sale')
      if (compareBadge) {
        compareBadge.removeAttribute('hidden')
        if (compareBadge.dataset.discountType === 'percentage') {
          const savings = 100 - (Math.round(selectedVariant.price / selectedVariant.compare_at_price * 100)) + '%'
          compareBadge.textContent = `-${savings}`
        } else {
          const savings = window.Shopify.formatMoney(selectedVariant.compare_at_price - selectedVariant.price)
          compareBadge.textContent = `${window.theme.locales.product.save} ${savings}`
        }
      } else {
        comparePrice.textContent = ''
        comparePrice.setAttribute('hidden', 'hidden')
        finalPrice.innerHTML = window.Shopify.formatMoney(selectedVariant.price)
        finalPrice.classList.remove('product-price-final-sale')
        compareBadge.textContent = ''
        compareBadge.setAttribute('hidden', 'hidden')
      }
    }

    if (selectedVariant.available) {
      soldOutBadge.setAttribute('hidden', 'hidden')
    } else {
      soldOutBadge.removeAttribute('hidden')
    }
  }

  adjustButtons(selectedVariant) {
    if (!this.atcBtn) return

    if (selectedVariant) {
      if (selectedVariant.available) {
        this.atcBtn.removeAttribute('disabled')
        this.buyBtn?.removeAttribute('disabled')
        this.atcBtn.innerHTML = window.theme.locales.product.add_to_cart
      } else {
        this.atcBtn.setAttribute('disabled', 'disabled')
        this.buyBtn?.setAttribute('disabled', 'disabled')
        this.atcBtn.innerHTML = window.theme.locales.product.sold_out
      }
    } else {
      this.atcBtn.setAttribute('disabled', 'disabled')
      this.buyBtn?.setAttribute('disabled', 'disabled')
      this.atcBtn.innerHTML = window.theme.locales.product.unavailable
    }
  }

  async fetchNewDocument(selectedVariant) {
    const respoonse = await fetch(`${this.form.dataset.productUrl}?variant=${selectedVariant.id}`)
    const text = await respoonse.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    window.dispatchEvent(new CustomEvent('td.product.variant.change.newDoc', {
      detail: newDocument
    }))
  }

  async onSubmit(event) {
    event.preventDefault()

    this.atcBtn.classList.add('loading')
    this.atcBtn.disabled = true
    this.atcBtn.setAttribute('aria-busy', 'true')

    const formData = new FormData(this.form)

    await document.querySelector('cart-container').add(formData)

    this.atcBtn.classList.remove('loading')
    this.atcBtn.disabled = false
    this.atcBtn.setAttribute('aria-busy', 'false')
  }

  onClickBuyBtn() {
    this.buyBtn.classList.add('loading')
    const variantId = this.form.querySelector('[name="id"]').value
    const qty = Number(this.form.querySelector('input[name="quantity"]')?.value || 1)
    window.location.href = `/cart/${variantId}:${qty}`
  }

  onChangeVariant(select) {
    const variantImage = select[select.selectedIndex].dataset.variantImage

    if (variantImage.length && select.closest('.product-card')) {
      select.closest('.product-card').querySelector('.product-card-img-wrapper img').setAttribute('src', variantImage)
    }

    if (variantImage.length && select.closest('.quick-view-offcanvas')) {
      const carousel = select.closest('.quick-view-offcanvas').querySelector('.quick-view-carousel')
      const imgWidth = carousel.querySelector('img').getAttribute('width')
      const imgheight = carousel.querySelector('img').getAttribute('height')

      carousel.querySelector('.carousel-inner').insertAdjacentHTML('beforeend', `
        <div class="carousel-item">
          <img src="${variantImage}" alt="" class="img-fluid" width="${imgWidth}" height="${imgheight}" loading="lazy">
        </div>
      `)

      const carouselSlideCount = carousel.querySelectorAll('.carousel-item').length
      window.bootstrap.Carousel.getOrCreateInstance(carousel).to(carouselSlideCount - 1)
    }
  }

  handleOutOfStockOptions() {
    if (!this.form.dataset.variants) return

    const variants = JSON.parse(this.form.dataset.variants)
    // console.log(variants)

    const selectedOption1 = this.form.querySelector('input[data-option-position="1"]:checked')?.value
    const selectedOption2 = this.form.querySelector('input[data-option-position="2"]:checked')?.value
    const selectedOption3 = this.form.querySelector('input[data-option-position="3"]:checked')?.value

    this.form.querySelectorAll('input[data-option-position="1"]').forEach(input => {
      const correspondingVariant = variants.find(variant => {
        if (selectedOption3) {
          if (variant.option1 === input.value && variant.option2 === selectedOption2 && variant.option3 === selectedOption3) return variant
        } else if (selectedOption2) {
          if (variant.option1 === input.value && variant.option2 === selectedOption2) return variant
        } else {
          if (variant.option1 === input.value) return variant
        }
        return null
      })

      if (correspondingVariant?.available) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })

    this.form.querySelectorAll('input[data-option-position="2"]').forEach(input => {
      const correspondingVariant = variants.find(variant => {
        if (selectedOption3) {
          if (variant.option2 === input.value && variant.option1 === selectedOption1 && variant.option3 === selectedOption3) return variant
        } else {
          if (variant.option2 === input.value && variant.option1 === selectedOption1) return variant
        }
        return null
      })

      if (correspondingVariant?.available) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })

    this.form.querySelectorAll('input[data-option-position="3"]').forEach(input => {
      const correspondingVariant = variants.find(variant => {
        if (variant.option3 === input.value && variant.option1 === selectedOption1 && variant.option2 === selectedOption2) return variant
        return null
      })

      if (correspondingVariant?.available) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })
  }
}
customElements.define('product-form', ProductForm)

class ProductMediaGallery extends HTMLElement {
  constructor() {
    super()

    const initialSlide = Number(this.dataset.initialSlide)

    /** @type {Swiper} */
    this.thumbs = new window.Swiper(this.querySelector('.swiper-thumbs'), this.thumbsOptions())

    /** @type {Swiper} */
    this.main = new window.Swiper(this.querySelector('.swiper-main'), this.mainOptions())

    this.main.slideTo(initialSlide)

    this.setStickyPosition()
    this.listenVariantChange()
    this.initFullScreenGallery()
  }

  thumbsOptions() {
    /** @type {SwiperOptions} */
    const options = {
      slidesPerView: Number(this.dataset.thumbsPerView),
      spaceBetween: 10,
      mousewheel: true
    }
    return options
  }

  mainOptions() {
    /** @type {SwiperOptions} */
    const options = {
      effect: this.dataset.effect,
      speed: Number(this.dataset.speed),
      rewind: true,
      pagination: {
        enabled: this.dataset.pagination === 'bullets' || this.dataset.pagination === 'fraction',
        type: this.dataset.pagination,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      scrollbar: {
        enabled: this.dataset.pagination === 'scrollbar',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true,
        hide: true
      },
      thumbs: {
        swiper: this.thumbs,
        autoScrollOffset: 1
      },
      cubeEffect: {
        shadow: false
      },
      creativeEffect: {
        prev: {
          shadow: true,
          origin: 'left center',
          translate: ['-5%', 0, -200],
          rotate: [0, 100, 0]
        },
        next: {
          origin: 'right center',
          translate: ['5%', 0, -200],
          rotate: [0, -100, 0]
        }
      },
      breakpoints: {
        0: { slidesPerView: 1 * (this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1) },
        600: { slidesPerView: 1 }
      },
      on: {
        slideChange: this.onSlideChange.bind(this)
      }
    }
    return options
  }

  onSlideChange() {
    this.querySelectorAll('video').forEach(video => video.pause())

    setTimeout(() => {
      if (this.querySelector('.swiper-main .swiper-slide-active video')) {
        this.querySelector('.swiper-main-wrapper').setAttribute('data-active-slide-is-video', 'true')
      } else {
        this.querySelector('.swiper-main-wrapper').setAttribute('data-active-slide-is-video', 'false')
      }
    }, 500)
  }

  setStickyPosition() {
    if (this.closest('.product-main') && window.matchMedia('(min-width: 1200px)').matches) {
      const headerGroup = document.querySelector('#header-group.sticky-top')
      const pdpExtraContent = document.querySelector('#pdp-extra-content')

      let oldScroll = window.scrollY

      window.addEventListener('scroll', () => {
        const newScroll = window.scrollY
        if (newScroll > oldScroll) {
          if (newScroll > headerGroup.clientHeight) {
            this.style.top = '20px'
            if (pdpExtraContent) {
              document.querySelector('#pdp-extra-content').style.top = '20px'
            }
          }
        } else if (newScroll < oldScroll) {
          this.style.top = `${headerGroup.clientHeight + 20}px`
          if (pdpExtraContent) {
            document.querySelector('#pdp-extra-content').style.top = `${headerGroup.clientHeight + 20}px`
          }
        }

        oldScroll = Math.max(window.scrollY, 0)
      })
    }
  }

  listenVariantChange() {
    window.addEventListener('td.product.variant.change', (event) => {
      const selectedVariant = event.detail

      if (selectedVariant.featured_media) {
        this.main.slideTo(selectedVariant.featured_media.position - 1)
      }
    }, false)
  }

  async initFullScreenGallery() {
    if (this.dataset.fullScreen === 'false') return

    const vendorScript = document.querySelector('script[src*="vendor-glightbox.min"]')

    vendorScript.onload = () => {
      window.GLightbox({
        selector: `[data-gallery="gallery-${this.dataset.productId}"]`,
        loop: true,
        openEffect: 'zoom',
        closeEffect: 'fade',
        slideEffect: this.dataset.fullScreenEffect
      })
    }
  }
}
customElements.define('product-media-gallery', ProductMediaGallery)

class ProductQtySwitcher extends HTMLElement {
  constructor() {
    super()

    this.qtyInput = this.querySelector('input')
    this.minusBtn = this.querySelector('button.btn-minus')
    this.plusBtn = this.querySelector('button.btn-plus')

    this.qtyInput.addEventListener('change', () => this.onQtyInputChange())
    this.minusBtn.addEventListener('click', () => this.onMinusBtnClick())
    this.plusBtn.addEventListener('click', () => this.onPlusBtnClick())

    window.addEventListener('td.product.variant.change.newDoc', (event) => this.onVariantChange(event))
  }

  onQtyInputChange() {
    this.validateButtons()
  }

  onMinusBtnClick() {
    this.qtyInput.value = Number(this.qtyInput.value) - 1
    this.validateButtons()
    this.qtyInput.dispatchEvent(new CustomEvent('change'))
  }

  onPlusBtnClick() {
    this.qtyInput.value = Number(this.qtyInput.value) + 1
    this.validateButtons()
    this.qtyInput.dispatchEvent(new CustomEvent('change'))
  }

  validateButtons() {
    if (this.qtyInput.getAttribute('min') && Number(this.qtyInput.value) <= Number(this.qtyInput.getAttribute('min'))) {
      this.minusBtn.disabled = true
      this.qtyInput.value = this.qtyInput.getAttribute('min')
    } else {
      this.minusBtn.disabled = false
    }
    if (this.qtyInput.getAttribute('max') && Number(this.qtyInput.value) >= Number(this.qtyInput.getAttribute('max'))) {
      this.plusBtn.disabled = true
      this.qtyInput.value = this.qtyInput.getAttribute('max')
    } else {
      this.plusBtn.disabled = false
    }
  }

  onVariantChange(event) {
    if (!this.closest('.product-block-atc')) return

    const newDoc = event.detail
    const newQtyInput = newDoc.querySelector('.product-block-atc .qty-switcher input')

    this.qtyInput.setAttribute('max', newQtyInput.getAttribute('max'))
    this.validateButtons()
  }
}
customElements.define('product-qty-switcher', ProductQtySwitcher)

class ProductVariantSelector extends HTMLElement {
  constructor() {
    super()

    const select = this.querySelector('select')

    select.addEventListener('change', () => {
      const variantImage = select[select.selectedIndex].dataset.variantImage
      if (!variantImage.length) return

      const produtcImg = this.closest('.product-card')?.querySelector('.product-card-img')

      if (produtcImg) {
        produtcImg.setAttribute('src', variantImage)
      }

      const carousel = this.closest('.product-card').querySelector('.product-card-img-wrapper .carousel')

      if (carousel) {
        window.bootstrap.Carousel.getOrCreateInstance(carousel).to(0)
      }
    })
  }
}
customElements.define('product-variant-selector', ProductVariantSelector)


class ProductQuickButton extends HTMLElement {
  constructor() {
    super()

    this.btn = this.querySelector('.btn-quick-view')
    this.modalCustomElem = document.querySelector('product-quick-view-offcanvas')

    this.btn.addEventListener('click', async (event) => this.fetchProductData(event))
  }

  async fetchProductData(event) {
    event.preventDefault()

    this.setLoading(true)

    const buildProductJsonUrl = (rawUrl) => {
      try {
        const url = new URL(rawUrl, window.location.origin)
        if (!url.pathname.endsWith('.js')) {
          url.pathname = url.pathname.replace(/\/$/, '') + '.js'
        }
        return url.toString()
      } catch (e) {
        const parts = String(rawUrl || '').split(/([?#].*)/)
        const base = (parts[0] || '').replace(/\/$/, '') + '.js'
        const tail = parts[1] || ''
        return base + tail
      }
    }

    const response = await fetch(buildProductJsonUrl(this.btn.dataset.productUrl))

    if (response.ok) {
      const data = await response.json()
      console.log(data)

      document.querySelector('product-quick-view-offcanvas').showModal(data)
    } else {
      // TODO: Handle Errors
    }

    this.setLoading(false)
  }

  setLoading(isLoading) {
    if (isLoading) {
      this.btn.classList.add('loading')
      this.btn.disabled = true
      this.btn.setAttribute('aria-busy', 'true')
    } else {
      this.btn.classList.remove('loading')
      this.btn.disabled = false
      this.btn.removeAttribute('aria-busy')
    }
  }
}
customElements.define('product-quick-view-button', ProductQuickButton)

class ProductQuickViewModal extends HTMLElement {
  constructor() {
    super()

    this.modalElem = document.querySelector('#quick-view-offcanvas')

    this.modalElem.addEventListener('hidden.bs.offcanvas', () => {
      this.modalElem.querySelector('[data-quick-view-contents]').innerHTML = ''
    })

    window.addEventListener('td.cart.added', () => {
      window.bootstrap.Offcanvas.getOrCreateInstance(this.modalElem).hide()
    })
  }

  buildImageUrl(src) {
    try {
      const url = new URL(src, window.location.origin)
      url.searchParams.set('width', this.dataset.imgWidth)
      url.searchParams.set('height', this.dataset.imgHeight)
      url.searchParams.set('crop', 'center')
      return url.toString()
    } catch (e) {
      const sep = src.includes('?') ? '&' : '?'
      return `${src}${sep}width=${this.dataset.imgWidth}&height=${this.dataset.imgHeight}&crop=center`
    }
  }

  async showModal(data) {
    const product = data

    if (!this.modalElem) {
      this.modalElem = document.querySelector('#quick-view-offcanvas')
    }

    if (!this.modalElem) {
      console.error('Quick view offcanvas element not found')
      return
    }

    let imagesHtml = ''
    let variantsHtml = ''

    product.images.forEach((image, index) => {
      const imageSrc = this.buildImageUrl(image)
      imagesHtml += `
        <div class="carousel-item ${index === 0 ? 'active' : ''}">
          <img 
            src="${imageSrc}" 
            data-original-src="${imageSrc}"
            alt="" 
            class="img-fluid w-100" 
            width="${this.dataset.imgWidth}" 
            height="${this.dataset.imgHeight}" 
            loading="lazy">
        </div>
      `
    })

    product.variants.forEach(variant => {
      const variantImage = variant.featured_image ? this.buildImageUrl(variant.featured_image.src) : ''

      variantsHtml += `
        <option 
          value="${variant.id}" 
          data-variant-image="${variantImage}"
          ${variant.available ? '' : 'disabled'}>
          ${variant.title} - ${window.Shopify.formatMoney(variant.price)}
          ${variant.available ? '' : `(${window.theme.locales.product.sold_out})`}
        </option>
      `
    })

    const mainHtml = `
      <div class="row mx-0">
        <div class="d-flex flex-columnpx-0">
          <div 
            id="carousel-${product.id}"
            class="quick-view-carousel carousel slide">
            <div class="carousel-inner">
              ${imagesHtml}
            </div>
            <div class="" ${product.images.length > 1 ? '' : 'hidden'}>
              <button 
                class="carousel-control carousel-control-prev" 
                type="button" 
                data-bs-target="#carousel-${product.id}" 
                data-bs-slide="prev"
                aria-label="Previous">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" class="svg-icon-arrow-left " viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M19 12H6M12 5l-7 7 7 7"/>
                </svg>
              </button>
              <button 
                class="carousel-control carousel-control-next" 
                type="button" 
                data-bs-target="#carousel-${product.id}" 
                data-bs-slide="next"
                aria-label="Next">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" class="svg-icon-arrow-right " viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M5 12h13M12 5l7 7-7 7"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="d-flex flex-columnpx-0">
          <div class="quick-view-content p-6 w-100">
            <h1 class="title product-title h3 mb-5">
              ${product.title}
            </h1>
            <p class="product-price mb-5" ${product.variants.length === 1 ? '' : 'hidden'}>
              <span ${product.compare_at_price > product.price ? '' : 'hidden'}>
                <span class="visually-hidden">
                  ${window.theme.locales.product.regular_price}
                </span>
                <span class="product-price-compare">
                  ${window.Shopify.formatMoney(product.compare_at_price)}
                </span>
                <span class="visually-hidden">
                  ${window.theme.locales.product.sale_price}
                </span>
                <span class="product-price-final product-price-sale">
                  ${window.Shopify.formatMoney(product.price)}
                </span>
              </span>
              <span class="product-price-final" ${product.compare_at_price > product.price ? 'hidden' : ''}>
                ${window.Shopify.formatMoney(product.price)}
              </span>
            </p>
            <product-form>
              <form method="post" action="${window.Shopify.routes.cart_add_url}" class="shopify-product-form">
                <select 
                  class="form-select mb-4"
                  name="id" 
                  aria-label="${window.theme.locales.product.select_variant}"
                  ${product.variants.length === 1 ? 'hidden' : ''}>
                  ${variantsHtml}
                </select>
                <button
                  class="btn btn-atc w-100 ${this.dataset.atcBtnColor}"
                  type="submit"
                  name="add"
                  ${product.available ? '' : 'disabled'}>
                  ${product.available ? window.theme.locales.product.add_to_cart : window.theme.locales.product.sold_out}
                </button>
              </form>
            </product-form>
            <a href="${product.url}" class="btn btn-link w-100 btn-sm mt-3">
              ${window.theme.locales.product.view_full_details}
            </a>
          </div>
        </div>
      </div>
    `

    const contentsContainer = this.modalElem.querySelector('[data-quick-view-contents]')
    if (!contentsContainer) {
      console.error('Quick view contents container not found')
      return
    }

    contentsContainer.innerHTML = mainHtml
    this.setupQuickViewVariantSync()
    window.bootstrap.Offcanvas.getOrCreateInstance(this.modalElem).show()
    window.dispatchEvent(new CustomEvent('td.product.quick_view.modal_shown'))
  }

  setupQuickViewVariantSync() {
    const select = this.modalElem.querySelector('.quick-view-content select[name="id"]')
    if (!select) return

    const carousel = this.modalElem.querySelector('.quick-view-carousel')
    if (!carousel) return

    const handler = event => this.updateQuickViewVariantImage(event.currentTarget, carousel)

    select.removeEventListener('change', this.quickViewVariantHandler)
    select.addEventListener('change', handler)

    this.quickViewVariantHandler = handler
  }

  updateQuickViewVariantImage(select, carousel) {
    const selectedOption = select.options[select.selectedIndex]
    if (!selectedOption) return

    const variantImage = selectedOption.dataset.variantImage
    if (!variantImage) return

    const carouselInstance = window.bootstrap.Carousel.getOrCreateInstance(carousel)
    const slides = [...carousel.querySelectorAll('.carousel-item')]

    const matchingSlideIndex = slides.findIndex(slide => {
      const img = slide.querySelector('img')
      if (!img) return false
      return img.dataset.originalSrc === variantImage
    })

    if (matchingSlideIndex >= 0) {
      carouselInstance.to(matchingSlideIndex)
      return
    }
  }
}
customElements.define('product-quick-view-offcanvas', ProductQuickViewModal)

class ProductDropupSelector extends HTMLElement {
  constructor() {
    super()

    this.productCard = this.closest('.product-card')
    this.dropdownBtn = this.querySelector('.dropdown-toggle')

    this.querySelector('.dropdown-menu').style.maxHeight =
      this.productCard.offsetHeight - this.dropdownBtn.offsetHeight - 2 + 'px'

    this.addEventListener('show.bs.dropdown', (event) => {
      const isMobile = window.matchMedia('(max-width: 599px').matches

      if (isMobile) {
        event.preventDefault()
        this.initOffcanvas()
      } else {
        this.productCard.querySelector('.product-card-img-wrapper').style.opacity = '.2'
      }
    })
    this.addEventListener('hide.bs.dropdown', (event) => {
      const isMobile = window.matchMedia('(max-width: 499px').matches

      if (isMobile) {
        event.preventDefault()
        this.removeOffcanvas()
      } else {
        this.productCard.querySelector('.product-card-img-wrapper').style.opacity = '1'
      }
    })

    this.querySelectorAll('.dropdown-menu button').forEach(btn => {
      btn.addEventListener('click', () => this.addToCart(btn))
    })
  }

  async addToCart(btn) {
    window.bootstrap.Dropdown.getOrCreateInstance(this).hide()

    this.dropdownBtn.classList.add('loading')
    this.dropdownBtn.disabled = true
    this.dropdownBtn.setAttribute('aria-busy', 'true')

    const items = [{
      id: Number(btn.dataset.variantId),
      quantity: 1
    }]

    await document.querySelector('cart-container').add({ items })

    this.dropdownBtn.classList.remove('loading')
    this.dropdownBtn.disabled = false
    this.dropdownBtn.setAttribute('aria-busy', 'false')
  }

  initOffcanvas() {
    const html = `
      <div id="product-dropup-select-offcanvas" class="offcanvas offcanvas-bottom" tabindex="-1" aria-labelledby="product-dropup-select-offcanvas-title">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="product-dropup-select-offcanvas-title">
            ${this.dropdownBtn.textContent}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body p-0">
          <ul class="dropdown-menu">
            ${this.querySelector('.dropdown-menu').innerHTML}
          </ul>
        </div>
      </div>
    `
    document.body.insertAdjacentHTML('beforeend', html)

    window.bootstrap.Offcanvas.getOrCreateInstance('#product-dropup-select-offcanvas').show()

    document.querySelectorAll('#product-dropup-select-offcanvas .dropdown-menu button').forEach(btn => {
      btn.addEventListener('click', () => {
        this.addToCart(btn)
        window.bootstrap.Offcanvas.getOrCreateInstance('#product-dropup-select-offcanvas').hide()
      })
    })

    document.querySelector('#product-dropup-select-offcanvas').addEventListener('hidden.bs.offcanvas', () => {
      document.querySelector('#product-dropup-select-offcanvas').remove()
    })
  }
}
customElements.define('product-dropup-selector', ProductDropupSelector)

class ProductStockIndicator extends HTMLElement {
  constructor() {
    super()

    this.progressBar = this.querySelector('.progress-bar')
    this.animateProgressBar()
    this.handleVariantChange()
  }

  animateProgressBar() {
    setTimeout(() => {
      this.progressBar.style.width = this.progressBar.dataset.width
    }, 250)
  }

  handleVariantChange() {
    window.addEventListener('td.product.variant.change', async () => {
      this.querySelector('.product-block-stock-indicator-inner').style.opacity = '.25'
    })

    window.addEventListener('td.product.variant.change.newDoc', async (e) => {
      const newDoc = e.detail

      this.replaceWith(newDoc.querySelector('[id*="product-block-stock-indicator"]'))
      this.animateProgressBar()
    })
  }
}
customElements.define('product-stock-indicator', ProductStockIndicator)

class ProductQuantityBreaks extends HTMLElement {
  constructor() {
    super()

    this.handleInputChange()
    this.handleVariantChange()
  }

  handleInputChange() {
    this.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', () => {
        const qtyField = input.closest('form').querySelector('[name="quantity"]')
        qtyField.value = input.value
        qtyField.dispatchEvent(new CustomEvent('change'))

        const atcBtn = this.closest('form').querySelector('.btn-atc')

        setTimeout(() => {
          atcBtn.classList.add('animate__animated', 'animate__shakeX')
        }, 250)

        setTimeout(() => {
          atcBtn.classList.remove('animate__animated', 'animate__shakeX')
        }, 1500)
      })
    })
  }

  handleVariantChange() {
    window.addEventListener('td.product.variant.change', async () => {
      this.querySelector('.product-block-quantity-breaks-list').style.opacity = '.25'
    })

    window.addEventListener('td.product.variant.change.newDoc', async (e) => {
      const newDoc = e.detail

      this.replaceWith(newDoc.querySelector('product-quantity-breaks'))
      this.handleInputChange()
    })
  }
}
customElements.define('product-quantity-breaks', ProductQuantityBreaks)

class FileUploadPersonalizationField extends HTMLElement {
  constructor() {
    super()

    this.loadStyleScripts()

    const vendorScript = document.querySelector('script[src*="plugin-image-preview"]')
    vendorScript.onload = () => {
      this.init()
    }

    window.addEventListener('td.product.quick_view.modal_shown', () => this.init())
  }

  loadStyleScripts() {
    if (document.querySelector('script[src*="plugin-image-preview"]')) return

    const style1 = document.createElement('link')
    style1.setAttribute('href', 'https://cdn.jsdelivr.net/npm/filepond@4.31.1/dist/filepond.min.css')
    style1.setAttribute('rel', 'stylesheet')
    style1.setAttribute('integrity', 'sha256-a95jYCBL4++k1XyLYgulKmY33bIJIVYMsJO/RNytaJM=')
    style1.setAttribute('crossorigin', 'anonymous')
    document.head.appendChild(style1)

    const style2 = document.createElement('link')
    style2.setAttribute('href', 'https://cdn.jsdelivr.net/npm/filepond-plugin-image-preview@4.6.12/dist/filepond-plugin-image-preview.min.css')
    style2.setAttribute('rel', 'stylesheet')
    style2.setAttribute('integrity', 'sha256-YsO8aMI20vSizdmc2mmWx2DU1wof4v60Nwy7hIBvdM8=')
    style2.setAttribute('crossorigin', 'anonymous')
    document.head.appendChild(style2)

    const script1 = document.createElement('script')
    script1.setAttribute('src', 'https://cdn.jsdelivr.net/npm/filepond@4.31.1/dist/filepond.min.js')
    script1.setAttribute('integrity', 'sha256-6yXpr8+sATA4Q2ANTyZmpn4ZGP7grbIRNpe9s0Y+iO0=')
    script1.setAttribute('crossorigin', 'anonymous')
    script1.setAttribute('defer', 'defer')
    document.head.appendChild(script1)

    const script2 = document.createElement('script')
    script2.setAttribute('src', 'https://cdn.jsdelivr.net/npm/filepond-plugin-image-preview@4.6.12/dist/filepond-plugin-image-preview.min.js')
    script2.setAttribute('integrity', 'sha256-1vQHytMrpOsKFyUUPuEVhxeNH6UhMX3uNetDRvlSpwU=')
    script2.setAttribute('crossorigin', 'anonymous')
    script1.setAttribute('defer', 'defer')
    document.head.appendChild(script2)
  }

  async init() {
    await new Promise(resolve => setTimeout(resolve, 200))

    window.FilePond.registerPlugin(window.FilePondPluginImagePreview)
    const inputElem = this.querySelector('input[type="file"]')

    window.FilePond.create(inputElem, {
      storeAsFile: true,
      labelIdle: this.querySelector('[data-label-text]').innerHTML
    })
  }
}
customElements.define('file-upload-personalization-field', FileUploadPersonalizationField)

class ProductLocalDelivery extends HTMLElement {
  constructor() {
    super()

    window.addEventListener('td.product.variant.change', async () => {
      this.querySelector('.product-block-local-delivery-list').style.opacity = '.25'
    })

    window.addEventListener('td.product.variant.change.newDoc', async (e) => {
      const newDoc = e.detail

      this.replaceWith(newDoc.querySelector('.product-block-local-delivery'))
    })
  }
}
customElements.define('product-local-delivery', ProductLocalDelivery)

// Product block collapses
if (window.matchMedia('(max-width: 1199px').matches) {
  document.querySelectorAll('.product-block-collapse').forEach(elem => {
    elem.querySelector('.collapse').addEventListener('shown.bs.collapse', () => {
      elem.scrollIntoView({ behavior: 'smooth' })
    })
  })
}

// Shopify Subscriptions app
const adjustShopifySubscriptionsStyling = () => {
  document.querySelectorAll('.shopify_subscriptions_app_block [type="radio"]').forEach(radio => {
    radio.classList.add('form-check-input')
  })
}
adjustShopifySubscriptionsStyling()
window.addEventListener('td.product.quick_view.modal_shown', adjustShopifySubscriptionsStyling)
